import React from 'react';
import { AdUI as StarryAdUI } from 'starry-sky-ui';
const AdUI: React.FC = () => {
  return <StarryAdUI />;
};

export default AdUI;